let RecaptchaKeys = {
    public: "6LcxivoUAAAAANHzUu-ns30ABiCod6LAYTy-_-ng"
};

let AjaxUrls = {
    domain: "https://avs4youapi.teamlab.info/"
};

export {RecaptchaKeys, AjaxUrls};